let notifier: (e: unknown) => void = () => {};
let messageResolver: (e: unknown) => string = () => '';

export function setUiErrorNotifier(fn: (e: unknown) => void): void {
	notifier = fn;
}

export function notifyUiError(e: unknown): void {
	notifier(e);
}

export function setUiErrorMessageResolver(fn: (e: unknown) => string): void {
	messageResolver = fn;
}

export function resolveUiErrorMessage(e: unknown): string {
	return messageResolver(e);
}
